import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Vi fandt ")
const _hoisted_2 = { class: "text-primary" }
const _hoisted_3 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_error = _resolveComponent("error")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_page = _resolveComponent("page")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_page, {
    isLoading: _ctx.loading,
    error: _ctx.error
  }, {
    default: _withCtx(() => [
      _createVNode(_component_AppHeader, { title: "Forbindelsesoversigt" }, {
        subtitle: _withCtx(() => [
          _createVNode("strong", null, [
            _hoisted_1,
            _createVNode("span", _hoisted_2, _toDisplayString(_ctx.history.length), 1),
            _createTextVNode(" forbindelse" + _toDisplayString(_ctx.history.length !== 1 ? "r" : ""), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_DataTable, {
        value: _ctx.history,
        stripedRows: true,
        responsiveLayout: "scroll",
        class: "text-start"
      }, {
        default: _withCtx(() => [
          (_ctx.history.length === 0 && !_ctx.loading)
            ? (_openBlock(), _createBlock(_component_error, {
                key: 0,
                error: {
            title: 'Ingen forbindelser',
            message: 'Der er ingen forbindelsesoversigt at vise endnu.',
          }
              }, null, 8, ["error"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Column, {
            field: "connectionName",
            header: "Forbindelsesnavn",
            sortable: true
          }, {
            body: _withCtx(({ data }) => [
              _withDirectives(_createVNode("span", null, [
                _createVNode("strong", null, _toDisplayString(data.connectionName ?? data.clientId), 1)
              ], 512), [
                [
                  _directive_tooltip,
                  'Navn',
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "isClientCredentialFlow",
            header: "Forbindelsestype",
            sortable: true
          }, {
            body: _withCtx(({ data }) => [
              _withDirectives(_createVNode("span", null, [
                _createTextVNode(_toDisplayString(data.isClientCredentialFlow ? "System" : "Bruger"), 1)
              ], 512), [
                [
                  _directive_tooltip,
                  'Forbindelsestype',
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "latestUsage",
            header: "Senest brugt",
            sortable: true
          }, {
            body: _withCtx(({ data }) => [
              _createVNode("div", _hoisted_3, [
                _withDirectives(_createVNode("span", null, [
                  _createTextVNode(_toDisplayString(data.latestUsage !== null ? data.latestUsage + " dage" : "-"), 1)
                ], 512), [
                  [
                    _directive_tooltip,
                    'Seneste anvendelse',
                    void 0,
                    { top: true }
                  ]
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }, 8, ["isLoading", "error"]))
}